import { useMemo } from "react";
import { useCsCfgObject } from "./useCsCfgObject";
/**
 * Returns attributes of current configuration object
 * - depends on React context {@linkcode sCfgObjectContext}
 * - requires {@linkcode CsAttributeController}
 * @category Hook
 * @category CsCfgObject
 * @export
 * @template TAttribute
 * @returns {TAttribute[]}
 */
export function useCsAttributes() {
    const { attributes = [] } = useCsCfgObject();
    return useMemo(() => {
        return attributes !== null && attributes !== void 0 ? attributes : [];
    }, [attributes]);
}
//# sourceMappingURL=useCsAttributes.js.map